// React
import React, { useEffect } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';

// Components
import LeadComponent from '../lead/Lead.component';

// Config
import { routesConfig } from './routes.config';

/**
 * Routes component to configure and handle main routes
 * https://github.com/remix-run/react-router/blob/main/docs/api.md
 *
 * @returns React.ReactElement
 */
export default function RoutesComponent(): React.ReactElement {
    const navigate = useNavigate();

    const routes = useRoutes([
        {
            path: routesConfig.fallback,
            element: <LeadComponent />,
        },
    ]);

    /**
     * @todo Improve routing and redirects
     */
    useEffect(() => {
        if (routes === null) {
            navigate(routesConfig.redirect, { replace: true });
        }
    }, [navigate, routes]);

    return <>{routes}</>;
}
